export default __webpack_public_path__ + "media/images/work_with_us/work_hero_lg-e441b42600fb235c4a9485c83304e4b9.png";